module.exports = __webpack_public_path__ + "static/media/radar_background.38af4ba3.jpg";